"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromSlices = exports.SlicesDef = void 0;
const tslib_1 = require("tslib");
const customtypes_1 = require("@prismicio/types-internal/lib/customtypes");
const fp_ts_1 = require("fp-ts");
const function_1 = require("fp-ts/lib/function");
const t = tslib_1.__importStar(require("io-ts"));
const utils_1 = require("../../utils");
const CompositeSliceDef_1 = require("./CompositeSliceDef");
const LegacySliceDef_1 = require("./LegacySliceDef");
const SharedSliceDef_1 = require("./SharedSliceDef");
const SliceDef_1 = require("./SliceDef");
const SlicesDefType = "Slices";
const codec = t.strict({
    name: t.string,
    slices: t.array(SliceDef_1.SliceDef),
});
exports.SlicesDef = new t.Type("SlicesDef", (u) => (0, utils_1.isFieldDef)(u) && u.def.type === SlicesDefType, (u) => {
    return (0, function_1.pipe)(codec.decode(u), fp_ts_1.either.map(({ name, slices }) => ({
        key: name,
        def: {
            type: SlicesDefType,
            slices: slices.reduce((acc, { key, def }) => ({ ...acc, [key]: def }), {}),
        },
    })));
}, (s) => s);
function fromSlices(def, sharedSlices) {
    var _a;
    const slicesMap = (0, utils_1.recordToMap)(sharedSlices);
    const slices = Object.entries(((_a = customtypes_1.Slices.toStatic(def, slicesMap).config) === null || _a === void 0 ? void 0 : _a.choices) || {}).reduce((acc, [sliceKey, sliceValue]) => {
        const sliceDef = (() => {
            switch (sliceValue.type) {
                case "SharedSlice":
                    return (0, SharedSliceDef_1.fromSharedSlice)(sliceValue);
                case "Slice":
                    return (0, CompositeSliceDef_1.fromCompositeSlice)(sliceValue);
                default:
                    return (0, LegacySliceDef_1.fromLegacySlice)(sliceValue);
            }
        })();
        return { ...acc, [sliceKey]: sliceDef };
    }, {});
    return {
        type: SlicesDefType,
        slices,
    };
}
exports.fromSlices = fromSlices;
